import {
  LevelName,
  PARCEL_ZOOM,
  BLOCKGROUP_ZOOM,
  MUNICIPALITY_LEVEL_NAME,
  BLOCKGROUP_LEVEL_NAME,
  PARCEL_LEVEL_NAME,
  MUNICIPALITY_ZOOM,
  AGGREGATED_MUNICIPALITY_LEVEL_NAME,
  TILESERVER_URL,
} from "app/constants"

import { getVersions } from "data/versions"

const VERSIONS = getVersions()

export function numberToZoom(zoom: number, isNational: boolean): LevelName {
  if (zoom < MUNICIPALITY_ZOOM) {
    return AGGREGATED_MUNICIPALITY_LEVEL_NAME
  } else if (zoom < BLOCKGROUP_ZOOM) {
    return MUNICIPALITY_LEVEL_NAME
  } else if (isNational) {
    return BLOCKGROUP_LEVEL_NAME
  } else if (zoom >= BLOCKGROUP_ZOOM && zoom < PARCEL_ZOOM) {
    return BLOCKGROUP_LEVEL_NAME
  } else {
    return PARCEL_LEVEL_NAME
  }
}

export function setInitialZoom(map: mapboxgl.Map) {
  if (map.getZoom() < PARCEL_ZOOM) {
    map.zoomTo(PARCEL_ZOOM)
  }
}

// Returns a formatter for the tileserver URL that incorporates versioning for the geography
// We use a curried function to allow consumers of this function to not need to know anything
// about versioning or geographies. they can simply pass the layer name and be good to go
// This is necessary for code we share between TES-UK and TES-Us (ie packages/react-hooks/use-map)
export function getTileServerUrlFormatter(geography: string): (layer: string) => string {
  return (layer: string) => {
    const version = VERSIONS.geographies[geography]?.version
    if (!version) {
      throw new Error(`Version not found for geography: ${geography}`)
    }
    // Strip geography prefix (e.g., "national_blockgroups" → "blockgroups")
    const tileName = layer.startsWith(`${geography}_`) ? layer.slice(geography.length + 1) : layer
    return `${TILESERVER_URL}/geography/${geography}/${version}/${tileName}/{z}/{x}/{y}.pbf`
  }
}
